<template>
  <div class="dynamicBox">
    <div v-for="(item, index) in list" :key="index">
      <div
        v-if="item.PostType == 4"
        class="la_item"
        @click="toPathDetail(item.Details[0].Url)"
      >
        <div class="lai_view" v-if="item.Content != '0'">
          {{ item.Content }}
        </div>
        <van-image :src="item.Details[0].Thumbnail" fit="cover"></van-image>
      </div>
      <div class="l_item" v-else>
        <div class="li_top" @click="toHomePage(item.MemberId)">
          <div class="avatarImg">
            <van-image
              fit="cover"
              :src="item.Photo"
              round
              error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
            />
            <div v-if="item.AuditState == 1">
              <img
                src="../../static/images/index/attestation.png"
                class="renzheng"
                v-if="item.ExhibitionState == 1"
              />
              <img
                src="../../static/images/index/attestation01.png"
                class="renzheng"
                v-else
              />
            </div>
          </div>
          <div
            class="li_top_r"
            :class="
              advert && item.IsTop ? 'width460' : '' || edit ? 'width520' : ''
            "
          >
            <div>{{ item.Headline }}</div>
            <div class="lrt_time">
              {{ item.Times }}
              <span v-if="item.Address" style="margin-left: 4px">
                | {{ item.Address }}
              </span>
              <div v-if="item.IsExhibition">2026光亚展参展商</div>
            </div>
          </div>
          <div
            class="trashIcon"
            @click.stop="trashClick(item.PostId, index)"
            v-if="edit"
          >
            <span class="iconfont icon-trash"></span>
          </div>
          <div class="topIcon" v-if="advert && item.IsTop">
            <span class="iconfont icon-back"></span>置顶
          </div>
        </div>
        <div
          class="li_mid"
          @click.stop="
            toDetail(item.PostType, item.PostId, item.ShareType, item.ShareId)
          "
        >
          <div class="text-box overFlowThree" v-if="item.Content">
            {{ item.Content }}
          </div>
          <!-- 图文 -->
          <div v-if="item.PostType == 1">
            <div class="img-box" v-if="item.Details.length == 1">
              <van-image
                fit="cover"
                :src="item.Details[0].Thumbnail"
                class="single"
              />
            </div>
            <div class="img-box" v-else>
              <van-image
                fit="cover"
                :src="pitem.Thumbnail"
                v-for="(pitem, pindex) in item.Details"
                :key="pindex"
                @click.stop="
                  toDetail(
                    item.PostType,
                    item.PostId,
                    item.ShareType,
                    item.ShareId,
                    pindex
                  )
                "
              />
            </div>
          </div>
          <!-- 视频 -->
          <div class="video-box" v-if="item.PostType == 2">
            <van-image fit="cover" :src="item.Details[0].Thumbnail" />
            <div
              class="iconfont icon-bofang"
              style="color: #dddddd; font-size: 50px"
            ></div>
          </div>
          <!-- 转发 -->
          <div class="original-box" v-if="item.PostType == 3">
            <van-image
              v-if="item.Details[0].Thumbnail"
              :src="item.Details[0].Thumbnail"
              fit="cover"
            ></van-image>
            <div
              class="overFlowThree"
              :style="item.Details[0].Thumbnail ? '' : 'width:100%;'"
            >
              {{ item.Details[0].Url }}
            </div>
          </div>
          <!-- 标签 -->
          <div class="label-box">
            <div class="circle" v-if="item.circle">
              <div class="iconfont icon-quanzi"></div>
              {{ item.circle }}
            </div>
            <div v-for="(tItem, tIndex) in item.TopicList" :key="tIndex">
              <div
                class="topic"
                @click.stop="toTopicDetail(tItem.TopicId)"
                :style="
                  tIndex == 1
                    ? 'color:#7896d3;'
                    : tIndex == 2
                    ? 'color:#d4a345;'
                    : ''
                "
              >
                #{{ tItem.TopicName }}#
              </div>
            </div>
          </div>
        </div>
        <div class="li_btm">
          <van-row>
            <van-col
              span="6"
              @click.stop="
                toDetail(
                  item.PostType,
                  item.PostId,
                  item.ShareType,
                  item.ShareId
                )
              "
            >
              <div
                class="iconfont icon-share1"
                style="font-size: 16px; margin-right: 4px"
              ></div>
              <div>分享</div></van-col
            >
            <van-col span="6"
              ><van-icon name="eye-o" size="18px" />
              <div v-if="item.Views">{{ item.Views }}</div></van-col
            >
            <van-col span="6" @click.stop="likeChange(item.PostId, index)">
              <van-icon
                :name="item.IsLike ? 'like' : 'like-o'"
                :color="item.IsLike ? '#d62f2f' : '#999'"
                size="17px"
                style="margin-right: 4px"
              />
              <div v-if="item.LikeCount">
                {{ item.LikeCount }}
              </div></van-col
            >
            <van-col
              span="6"
              @click.stop="
                toDetail(
                  item.PostType,
                  item.PostId,
                  item.ShareType,
                  item.ShareId
                )
              "
              ><van-icon name="chat-o" size="18px" style="margin-right: 4px" />
              <div v-if="item.Comment">
                {{ item.Comment }}
              </div></van-col
            >
          </van-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Row, Col, Icon, Image } from "vant";
import { deleteMemberPost } from "@/api/homepage";
import { createPostLike, cancelPostLike } from "@/api/index";
export default {
  name: "dynamicList",
  components: {
    "van-row": Row,
    "van-col": Col,
    "van-icon": Icon,
    "van-image": Image,
  },
  props: {
    list: {
      type: Array,
      value: [],
    },
    //是否可编辑页面（个人中心-本人）
    edit: {
      type: Boolean,
      value: false,
    },
    //是否有广告插入（首页）
    advert: {
      type: Boolean,
      value: false,
    },
    //是否可跳转个人中心（个人中心页面除外）
    homePage: {
      type: Boolean,
      value: true,
    },
  },
  watch: {
    $route(to, from) {
      this.$router.go(0);
    },
  },
  methods: {
    //广告位跳转
    toPathDetail(url) {
      if (url.split(":")[0] == "https") {
        window.location.href = url;
      }
    },

    //去详情页面
    toDetail(type, id, stype, sid, pindex) {
      if (type == 1) {
        this.$router.push({
          path: "/trendDetails",
          query: { tid: id, imgidx: pindex },
        });
      } else if (type == 2) {
        this.$router.push({ path: "/videoDetails", query: { vid: id } });
      } else if (type == 3) {
        if (stype == 2) {
          this.$router.push({
            path: "/videoDetail",
            query: { id: sid },
          });
        } else {
          this.$router.push({
            path: "/articleDetail",
            query: { id: sid },
          });
        }
      } else {
      }
    },

    //跳转个人主页
    toHomePage(mid) {
      this.$router.push({ path: "/homePage", query: { mid: mid } });
    },

    //跳转话题详情
    toTopicDetail(hid) {
      this.$router.replace({ path: "/hotTopicDetails", query: { hid: hid } });
    },

    //点赞操作
    likeChange(id, index) {
      var newlist = this.list;
      if (newlist[index].IsLike) {
        cancelPostLike({ PostId: id }).then((res) => {
          newlist[index].IsLike = false;
          newlist[index].LikeCount--;
        });
      } else {
        createPostLike({ PostId: id }).then((res) => {
          newlist[index].IsLike = true;
          newlist[index].LikeCount++;
        });
      }
      this.list = newlist;
    },

    //删除用户动态
    trashClick(id, idx) {
      var that = this;
      var data = {
        PostId: id,
      };
      deleteMemberPost(data).then((res) => {
        that.$toast.success("删除动态成功");
        setTimeout(() => {
          var newlist = that.list;
          newlist.splice(idx, 1);
          that.list = newlist;
        }, 1000);
      });
    },
  },
};
</script>
    
